import React from 'react';
import { makeIcon } from './Icons';
export var AirtableIcon = makeIcon({
  displayName: 'AirtableIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M7.141 1.449L1.18 3.916a.4.4 0 0 0 .005.741l5.988 2.375a2.221 2.221 0 0 0 1.638 0l5.987-2.375a.4.4 0 0 0 .005-.74L8.84 1.448a2.221 2.221 0 0 0-1.699 0z",
    fill: "#FFBF00"
  }), React.createElement("path", {
    d: "M8.522 8.329v5.932a.4.4 0 0 0 .547.372l6.671-2.59a.4.4 0 0 0 .252-.372V5.739a.4.4 0 0 0-.546-.372l-6.672 2.59a.4.4 0 0 0-.252.372z",
    fill: "#26B5F8"
  }), React.createElement("path", {
    d: "M6.964 8.635l-1.98.956-.201.097-4.18 2.003c-.265.128-.603-.065-.603-.36V5.764c0-.106.055-.198.128-.267a.454.454 0 0 1 .101-.076c.1-.06.242-.076.363-.028l6.339 2.512c.322.127.347.579.033.73z",
    fill: "#ED3049"
  }), React.createElement("path", {
    d: "M6.964 8.635l-1.98.956L.128 5.496a.454.454 0 0 1 .101-.076c.1-.06.242-.076.363-.028l6.339 2.512c.322.127.347.579.033.73z",
    fill: "#000",
    fillOpacity: ".25"
  }))
});
export var AirtableGreyIcon = makeIcon({
  displayName: 'AirtableGreyIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M7.141 1.449L1.18 3.916a.4.4 0 0 0 .005.741l5.988 2.375a2.221 2.221 0 0 0 1.638 0l5.987-2.375a.4.4 0 0 0 .005-.74L8.84 1.448a2.221 2.221 0 0 0-1.699 0z"
  }), React.createElement("path", {
    d: "M8.522 8.329v5.932a.4.4 0 0 0 .547.372l6.671-2.59a.4.4 0 0 0 .253-.372V5.739a.4.4 0 0 0-.547-.372l-6.672 2.59a.4.4 0 0 0-.252.372z"
  }), React.createElement("path", {
    d: "M6.964 8.635l-1.98.956-.201.097-4.18 2.003c-.265.128-.603-.065-.603-.36V5.764c0-.106.055-.198.128-.267a.454.454 0 0 1 .101-.076c.1-.06.242-.076.364-.028L6.93 7.904c.322.127.347.579.033.73z"
  }))
});
export var AsanaIcon = makeIcon({
  displayName: 'AsanaIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 4a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm4.5 8a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zM3.5 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    fill: "#F95353"
  }))
});
export var AsanaGreyIcon = makeIcon({
  displayName: 'AsanaGreyIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 4a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm4.5 8a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zM3.5 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
  }))
});
export var ClickUpIcon = makeIcon({
  displayName: 'ClickUpIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0z",
    fill: "url(#clickup-color-radial)"
  }), React.createElement("path", {
    d: "M7.972 12.752c3.671 0 4.917-3.303 3.39-4.352-.011 4.114-6.644 4.1-6.654 0-1.63 1.049-.406 4.352 3.264 4.352z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M10.794 5.367c1.187 1.008 1.217 1.893 1.204 2.08L8.004 4.872 4.002 7.447c-.013-.186.016-1.073 1.203-2.08.467-.363 1.478-1.228 2.148-1.805a1.003 1.003 0 0 1 1.304-.006l2.137 1.811z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "clickup-color-radial",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8 8) scale(10.7651)"
  }, React.createElement("stop", {
    stopColor: "#6A5FD7"
  }), React.createElement("stop", {
    offset: ".21",
    stopColor: "#6A5FD7"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#4B43AD"
  }))))
});
export var ClickUpGreyIcon = makeIcon({
  displayName: 'ClickUpGreyIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm-.028 12.752c3.671 0 4.917-3.303 3.39-4.352-.011 4.114-6.644 4.1-6.654 0-1.63 1.049-.406 4.352 3.264 4.352zm4.026-5.305c.013-.187-.017-1.072-1.204-2.08L8.657 3.556a1.003 1.003 0 0 0-1.304.006c-.67.577-1.681 1.442-2.148 1.805-1.187 1.007-1.216 1.894-1.203 2.08l4.002-2.575 3.994 2.575z"
  }))
});
export var DrawIOIcon = makeIcon({
  displayName: 'DrawIOIcon',
  viewBox: 719,
  content: React.createElement("g", {
    transform: "translate(0.000000,719.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, React.createElement("path", {
    d: "M0 3595 l0 -3595 3595 0 3595 0 0 3595 0 3595 -3595 0 -3595 0 0 -3595z m4319 2735 c162 -27 286 -148 321 -313 7 -36 10 -238 8 -623 -3 -569 -3 -569 -26 -626 -35 -86 -108 -160 -202 -206 l-78 -38 397 -677 396 -677 370 0 c398 -1 493 -8 564 -42 71 -34 154 -119 187 -191 l29 -62 0 -620 0 -620 -32 -66 c-40 -81 -102 -140 -191 -182 l-67 -32 -765 0 -765 0 -63 29 c-81 37 -171 131 -204 213 l-23 58 0 605 0 605 32 67 c76 162 212 237 431 238 28 0 52 2 52 4 0 1 -177 304 -393 672 l-394 669 -310 3 -310 2 -392 -668 c-215 -368 -391 -671 -391 -674 0 -3 45 -8 101 -12 159 -11 251 -56 329 -159 77 -102 75 -79 75 -757 l0 -605 -32 -67 c-54 -115 -150 -191 -273 -217 -40 -9 -250 -11 -785 -9 l-730 3 -65 31 c-113 53 -171 119 -210 233 -20 61 -21 76 -18 659 l3 597 27 57 c47 101 140 182 253 221 18 6 200 13 449 16 l419 6 393 670 c216 369 393 674 394 678 0 4 -8 10 -17 13 -133 42 -226 133 -267 260 -15 45 -16 117 -14 655 l3 604 27 56 c54 109 173 198 290 218 77 13 1388 13 1467 1z"
  }))
});
export var FigmaIcon = makeIcon({
  displayName: 'FigmaIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("g", {
    clipPath: "url(#figma-color-clip)"
  }, React.createElement("path", {
    d: "M5.667 16a2.668 2.668 0 0 0 2.667-2.667v-2.667H5.667a2.668 2.668 0 0 0 0 5.334z",
    fill: "#0ACF83"
  }), React.createElement("path", {
    d: "M3 8a2.668 2.668 0 0 1 2.667-2.667h2.667v5.333H5.667A2.667 2.667 0 0 1 3 8z",
    fill: "#A259FF"
  }), React.createElement("path", {
    d: "M3 2.667A2.668 2.668 0 0 1 5.667 0h2.667v5.333H5.667A2.667 2.667 0 0 1 3 2.667z",
    fill: "#F24E1E"
  }), React.createElement("path", {
    d: "M8.333 0H11a2.667 2.667 0 0 1 0 5.333H8.333V0z",
    fill: "#FF7262"
  }), React.createElement("path", {
    d: "M13.667 8a2.668 2.668 0 0 1-5.334 0 2.668 2.668 0 0 1 5.334 0z",
    fill: "#1ABCFE"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "figma-color-clip"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))))
});
export var FigmaGreyIcon = makeIcon({
  displayName: 'FigmaGreyIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M5.668 16a2.668 2.668 0 0 0 2.666-2.667v-2.666H5.668a2.668 2.668 0 0 0 0 5.333z"
  }), React.createElement("path", {
    d: "M3.001 8a2.668 2.668 0 0 1 2.667-2.667h2.666v5.334H5.668A2.668 2.668 0 0 1 3 8z"
  }), React.createElement("path", {
    d: "M3.001 2.667A2.668 2.668 0 0 1 5.668 0h2.666v5.333H5.668A2.668 2.668 0 0 1 3 2.667z"
  }), React.createElement("path", {
    d: "M8.334 0h2.667a2.668 2.668 0 0 1 0 5.333H8.334V0z"
  }), React.createElement("path", {
    d: "M13.668 8a2.668 2.668 0 0 1-5.334 0 2.668 2.668 0 0 1 5.334 0z"
  }))
});
export var GoogleDriveIcon = makeIcon({
  displayName: 'GoogleDriveIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("g", {
    clipPath: "url(#google-drive-clip-0)"
  }, React.createElement("path", {
    d: "M2.8 14.944L0 10.148l5.2-9.092L8 5.852l-5.2 9.092z",
    fill: "#0DA960"
  }), React.createElement("path", {
    d: "M2.8 14.944l2.8-4.796H16l-2.8 4.796H2.8z",
    fill: "url(#paint0_radial)"
  }), React.createElement("path", {
    d: "M16 10.148h-5.6L5.2 1.056h5.6l5.2 9.092z",
    fill: "url(#paint1_radial)"
  }), React.createElement("path", {
    d: "M8 10.148H5.6L6.8 8.05l-4 6.894L8 10.148z",
    fill: "#2D6FDD"
  }), React.createElement("path", {
    d: "M10.4 10.148H16L9.2 8.05l1.2 2.098z",
    fill: "#E5B93C"
  }), React.createElement("path", {
    d: "M6.8 8.05L8 5.852 5.2 1.056 6.8 8.05z",
    fill: "#0C9B57"
  })), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(30.112 -7.346 53.372) scale(31.1916)"
  }, React.createElement("stop", {
    stopColor: "#4387FD"
  }), React.createElement("stop", {
    offset: ".65",
    stopColor: "#3078F0"
  }), React.createElement("stop", {
    offset: ".91",
    stopColor: "#2B72EA"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#286EE6"
  })), React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(27.01576 15.63889 -15.63263 27.00494 25.457 10.662)"
  }, React.createElement("stop", {
    stopColor: "#FFD24D"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F6C338"
  })), React.createElement("clipPath", {
    id: "google-drive-clip-0"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))))
});
export var GoogleDriveGreyIcon = makeIcon({
  displayName: 'GoogleDriveGreyIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.15L2.8 15h10.4l2.8-4.85L10.8 1H5.2L0 10.15zm10.382-.025L8 6l-2.382 4.125h4.764z"
  }))
});
export var GoogleMapsIcon = makeIcon({
  displayName: 'GoogleMapsIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("g", {
    clipPath: "url(#google-maps-color-path-0)"
  }, React.createElement("path", {
    d: "M7.994 0C5.18 0 2.9 2.177 2.9 4.863c.002.838.201 1.662.635 2.39.131.214.253.428.362.64.1.153.197.306.288.458.104.145.204.29.3.437.398.537.76 1.064 1.105 1.57.24.387.51.801.748 1.211.718 1.243 1.217 2.457 1.397 4.225v.004c.055.124.157.202.267.202.122 0 .233-.095.282-.242.183-1.748.68-2.954 1.392-4.189.238-.41.508-.824.749-1.212.345-.505.707-1.032 1.104-1.569.096-.146.196-.292.3-.437.091-.152.188-.305.289-.458.109-.212.23-.426.361-.64.433-.729.607-1.552.609-2.39C13.088 2.177 10.808 0 7.994 0z",
    fill: "#DD4B3E"
  }), React.createElement("path", {
    d: "M7.994 6.552c.977 0 1.77-.757 1.77-1.69 0-.932-.793-1.689-1.77-1.689-.978 0-1.77.757-1.77 1.69 0 .932.792 1.689 1.77 1.689z",
    fill: "#802D27"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "google-maps-color-path-0"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))))
});
export var GoogleMapsGreyIcon = makeIcon({
  displayName: 'GoogleMapsGreyIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("g", {
    clipPath: "url(#google-maps-grey-path-0)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9 4.863C2.9 2.177 5.18 0 7.994 0c2.813 0 5.094 2.177 5.094 4.863-.001.838-.176 1.661-.609 2.39-.13.214-.252.428-.361.64-.101.153-.198.306-.288.458-.105.145-.205.29-.3.437a49.39 49.39 0 0 0-1.105 1.57 59.06 59.06 0 0 1-.221.351c-.178.282-.36.572-.528.86-.712 1.234-1.209 2.44-1.392 4.189-.049.147-.16.242-.282.242-.11 0-.212-.078-.267-.202v-.004c-.18-1.768-.68-2.982-1.397-4.225-.167-.288-.35-.578-.527-.86-.076-.119-.15-.236-.221-.351a49.486 49.486 0 0 0-1.105-1.57 11.41 11.41 0 0 0-.3-.437c-.09-.152-.187-.305-.288-.458a9.772 9.772 0 0 0-.362-.64c-.434-.728-.633-1.552-.635-2.39zm6.863 0c0 .932-.792 1.689-1.77 1.689-.976 0-1.769-.757-1.769-1.69 0-.932.793-1.689 1.77-1.689s1.77.757 1.77 1.69z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "google-maps-grey-path-0"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))))
});
export var GitHubIcon = makeIcon({
  displayName: 'GitHubIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M8 .197A8.001 8.001 0 0 0 5.472 15.79c.4.074.547-.174.547-.384 0-.192-.008-.821-.011-1.49-2.226.484-2.696-.943-2.696-.943-.364-.925-.888-1.171-.888-1.171-.726-.497.055-.486.055-.486.803.056 1.226.824 1.226.824.714 1.223 1.872.87 2.328.665.072-.517.28-.87.508-1.07-1.777-.202-3.645-.888-3.645-3.953 0-.874.313-1.587.825-2.148-.084-.201-.357-1.015.077-2.117 0 0 .672-.215 2.2.82a7.59 7.59 0 0 1 4.007 0c1.527-1.035 2.198-.82 2.198-.82.435 1.102.162 1.916.078 2.117.512.56.824 1.274.824 2.148 0 3.072-1.872 3.749-3.653 3.947.288.248.544.736.544 1.482 0 1.07-.01 1.931-.01 2.195 0 .213.145.462.55.384A8.005 8.005 0 0 0 16 8.197a8 8 0 0 0-8-8zM2.996 11.594c-.017.04-.08.051-.137.024-.057-.027-.09-.08-.071-.12.018-.04.08-.052.137-.025.058.027.091.08.071.12zm.394.352c-.038.035-.113.018-.163-.037-.051-.057-.063-.13-.024-.167.038-.035.112-.019.164.037.053.056.063.13.023.166zm.27.448c-.05.034-.128.002-.179-.07-.05-.07-.049-.156 0-.191.049-.036.128-.004.179.067.05.07.05.16 0 .194zm.456.52c-.043.048-.137.035-.205-.032-.069-.067-.09-.156-.046-.205.044-.048.139-.034.208.032.069.067.09.158.043.206v-.001zm.59.175c-.019.064-.109.091-.2.064-.09-.027-.15-.1-.131-.164.018-.063.11-.093.2-.064.092.029.15.101.132.165zm.673.075c.002.066-.075.12-.17.122-.095.001-.173-.051-.174-.116-.001-.065.075-.121.17-.123.096-.001.173.052.173.117zm.66-.025c.01.064-.055.13-.15.148-.095.017-.179-.023-.19-.087-.012-.064.055-.132.148-.15.093-.016.179.024.19.09l.001-.001z",
    fill: "#161614"
  }))
});
export var GitHubGreyIcon = makeIcon({
  displayName: 'GitHubGreyIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M8 .197A8.001 8.001 0 0 0 5.472 15.79c.4.074.547-.174.547-.384 0-.192-.008-.821-.011-1.49-2.226.484-2.696-.943-2.696-.943-.364-.925-.888-1.171-.888-1.171-.726-.497.055-.486.055-.486.803.056 1.226.824 1.226.824.714 1.223 1.872.87 2.328.665.072-.517.28-.87.508-1.07-1.777-.202-3.645-.888-3.645-3.953 0-.874.313-1.587.825-2.148-.084-.201-.357-1.015.077-2.117 0 0 .672-.215 2.2.82a7.59 7.59 0 0 1 4.007 0c1.527-1.035 2.198-.82 2.198-.82.435 1.102.162 1.916.078 2.117.512.56.824 1.274.824 2.148 0 3.072-1.872 3.749-3.653 3.947.288.248.544.736.544 1.482 0 1.07-.01 1.931-.01 2.195 0 .213.145.462.55.384A8.005 8.005 0 0 0 16 8.197a8 8 0 0 0-8-8z"
  }))
});
export var InVisionIcon = makeIcon({
  displayName: 'InVisionIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M14.55 0H1.45C.65 0 0 .65 0 1.45v13.1C0 15.35.65 16 1.45 16h13.1c.8 0 1.45-.65 1.45-1.45V1.45C16 .65 15.35 0 14.55 0z",
    fill: "#DC395F"
  }), React.createElement("path", {
    d: "M5.347 5.034a.966.966 0 0 0 .978-.963.966.966 0 0 0-.978-.963.966.966 0 0 0-.977.963c0 .546.445.963.977.963zm-2.026 5.158a3.308 3.308 0 0 0-.087.723c0 .848.46 1.411 1.438 1.411.81 0 1.468-.481 1.94-1.258l-.288 1.16h1.61l.92-3.69c.23-.935.675-1.42 1.35-1.42.532 0 .863.33.863.877 0 .158-.014.33-.072.517l-.474 1.696c-.072.245-.1.49-.1.719 0 .805.473 1.394 1.465 1.394.848 0 1.524-.546 1.898-1.854l-.633-.244c-.316.876-.59 1.035-.805 1.035-.215 0-.33-.144-.33-.431 0-.13.028-.273.071-.446l.46-1.652c.115-.388.159-.732.159-1.049 0-1.236-.748-1.88-1.653-1.88-.848 0-1.71.764-2.142 1.57l.316-1.446H6.77l-.345 1.273h1.15l-.708 2.835c-.556 1.236-1.577 1.256-1.705 1.227-.211-.047-.346-.127-.346-.4 0-.158.03-.385.101-.658l1.078-4.277h-2.73l-.346 1.273h1.136l-.733 2.995",
    fill: "#fff"
  }))
});
export var InVisionGreyIcon = makeIcon({
  displayName: 'InVisionGreyIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.45 0h13.1c.8 0 1.45.65 1.45 1.45v13.1c0 .8-.65 1.45-1.45 1.45H1.45A1.45 1.45 0 0 1 0 14.55V1.45C0 .65.65 0 1.45 0zm4.875 4.07a.966.966 0 0 1-.978.964.966.966 0 0 1-.977-.963c0-.546.445-.963.977-.963s.978.417.978.963zm-3.09 6.845c0-.215.028-.479.086-.723l.733-2.995H2.918l.345-1.273h2.731l-1.078 4.277c-.072.273-.1.5-.1.657 0 .274.134.354.345.401.128.03 1.15.01 1.705-1.227l.708-2.835h-1.15l.345-1.273h2.458L8.911 7.37c.431-.805 1.294-1.57 2.142-1.57.905 0 1.653.645 1.653 1.881 0 .317-.043.66-.159 1.049l-.46 1.652a1.908 1.908 0 0 0-.071.446c0 .287.115.43.33.43.216 0 .489-.158.805-1.034l.633.244c-.374 1.308-1.05 1.854-1.898 1.854-.991 0-1.466-.589-1.466-1.394 0-.23.029-.474.1-.719l.475-1.696c.058-.187.072-.359.072-.517 0-.546-.33-.877-.862-.877-.676 0-1.122.485-1.352 1.42l-.92 3.69h-1.61l.29-1.16c-.473.777-1.13 1.258-1.941 1.258-.978 0-1.438-.563-1.438-1.41z"
  }))
});
export var TrelloIcon = makeIcon({
  displayName: 'TrelloIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("g", {
    clipPath: "url(#trello-color-clip-0)"
  }, React.createElement("path", {
    d: "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z",
    fill: "#3279BA"
  }), React.createElement("path", {
    d: "M7 12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v9zm7-4a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5z",
    fill: "#fff"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "trello-color-clip-0"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))))
});
export var TrelloGreyIcon = makeIcon({
  displayName: 'TrelloGreyIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm6 11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h3zm7-4a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h3z"
  }))
});
export var TwitterIcon = makeIcon({
  displayName: 'TwitterIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M5.079 14.5c5.944 0 9.196-5.002 9.196-9.34 0-.142 0-.283-.01-.424a6.634 6.634 0 0 0 1.613-1.699c-.59.266-1.216.44-1.857.517a3.285 3.285 0 0 0 1.421-1.816 6.417 6.417 0 0 1-2.052.797 3.22 3.22 0 0 0-1.834-.992 3.192 3.192 0 0 0-2.049.346 3.266 3.266 0 0 0-1.42 1.54 3.333 3.333 0 0 0-.205 2.1 9.065 9.065 0 0 1-3.69-.996 9.204 9.204 0 0 1-2.97-2.434A3.33 3.33 0 0 0 .866 4.49c.186.814.67 1.526 1.355 1.99A3.17 3.17 0 0 1 .755 6.07v.041c0 .758.259 1.493.731 2.08.473.586 1.13.988 1.862 1.138a3.179 3.179 0 0 1-1.46.056 3.285 3.285 0 0 0 1.15 1.632 3.204 3.204 0 0 0 1.87.648 6.422 6.422 0 0 1-4.783 1.36 9.047 9.047 0 0 0 4.954 1.472",
    fill: "#1DA1F2"
  }))
});
export var TwitterGreyIcon = makeIcon({
  displayName: 'TwitterGreyIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M5.079 14.5c5.944 0 9.196-5.002 9.196-9.34 0-.142 0-.283-.01-.424a6.634 6.634 0 0 0 1.613-1.699c-.59.266-1.216.44-1.857.517a3.285 3.285 0 0 0 1.421-1.816 6.417 6.417 0 0 1-2.052.797 3.22 3.22 0 0 0-1.834-.992 3.192 3.192 0 0 0-2.049.346 3.266 3.266 0 0 0-1.42 1.54 3.333 3.333 0 0 0-.205 2.1 9.065 9.065 0 0 1-3.69-.996 9.204 9.204 0 0 1-2.97-2.434A3.33 3.33 0 0 0 .866 4.49c.186.814.67 1.526 1.355 1.99A3.17 3.17 0 0 1 .755 6.07v.041c0 .758.259 1.493.731 2.08.473.586 1.13.988 1.862 1.138a3.179 3.179 0 0 1-1.46.056 3.285 3.285 0 0 0 1.15 1.632 3.204 3.204 0 0 0 1.87.648 6.422 6.422 0 0 1-4.783 1.36 9.047 9.047 0 0 0 4.954 1.472"
  }))
});
export var YouTubeIcon = makeIcon({
  displayName: 'YouTubeIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M15.67 4.152a2.029 2.029 0 0 0-1.422-1.421C12.998 2.4 8 2.4 8 2.4s-4.998 0-6.248.33A2.029 2.029 0 0 0 .33 4.153C0 5.402 0 8 0 8s0 2.61.33 3.848a2.029 2.029 0 0 0 1.422 1.421C3.002 13.6 8 13.6 8 13.6s5.01 0 6.248-.33a2.029 2.029 0 0 0 1.421-1.422C16 10.598 16 8 16 8s0-2.61-.33-3.848z",
    fill: "red"
  }), React.createElement("path", {
    d: "M6.395 10.402L10.56 8 6.395 5.598v4.804z",
    fill: "#fff"
  }))
});
export var YouTubeGreyIcon = makeIcon({
  displayName: 'YouTubeGreyIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.248 2.73a2.029 2.029 0 0 1 1.421 1.422C16 5.39 16 8 16 8s0 2.598-.33 3.848a2.029 2.029 0 0 1-1.422 1.421C13.011 13.6 8 13.6 8 13.6s-4.998 0-6.248-.33A2.029 2.029 0 0 1 .33 11.847C0 10.61 0 8 0 8s0-2.598.33-3.848a2.029 2.029 0 0 1 1.422-1.421C3.002 2.4 8 2.4 8 2.4s4.998 0 6.248.33zM10.56 8l-4.165 2.402V5.598L10.56 8z"
  }))
});
export var JiraIcon = makeIcon({
  displayName: 'JiraIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M8 0a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 15.999 8L16 .7a.7.7 0 0 0-.7-.7H8z",
    fill: "#2684FF"
  }), React.createElement("path", {
    d: "M4 4a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 12 12L12 4.7a.7.7 0 0 0-.7-.7H4z",
    fill: "url(#paint0_linear)"
  }), React.createElement("path", {
    d: "M0 8a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 8 16L8 8.7a.7.7 0 0 0-.7-.7H0z",
    fill: "url(#paint1_linear)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "11.842",
    y1: "4.013",
    x2: "8.692",
    y2: "7.243",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: ".18",
    stopColor: "#0052CC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2684FF"
  })), React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: "7.842",
    y1: "8.013",
    x2: "4.692",
    y2: "11.243",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: ".18",
    stopColor: "#0052CC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2684FF"
  }))))
});
export var JiraGreyIcon = makeIcon({
  displayName: 'JiraGreyIcon',
  viewBox: 16,
  content: React.createElement("g", null, React.createElement("path", {
    d: "M8 0a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 15.999 8L16 .7a.7.7 0 0 0-.7-.7H8z"
  }), React.createElement("path", {
    d: "M4 4a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 12 12L12 4.7a.7.7 0 0 0-.7-.7H4z"
  }), React.createElement("path", {
    d: "M0 8a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 8 16L8 8.7a.7.7 0 0 0-.7-.7H0z"
  }))
}); // todo: Those will have to be provided by the application itself at some point

var iconByName = {
  asana: {
    grey: AsanaGreyIcon,
    colors: AsanaIcon
  },
  github: {
    grey: GitHubGreyIcon,
    colors: GitHubIcon
  },
  trello: {
    grey: TrelloGreyIcon,
    colors: TrelloIcon
  },
  clickup: {
    grey: ClickUpGreyIcon,
    colors: ClickUpIcon
  },
  jira: {
    grey: JiraGreyIcon,
    colors: JiraIcon
  }
};
export function getGreyIconByName(name) {
  // might throw
  try {
    return iconByName[name.toLowerCase()]['grey'];
  } catch (error) {
    return null;
  }
}
export function getActiveIconByName(name) {
  // might throw
  try {
    return iconByName[name.toLowerCase()]['colors'];
  } catch (error) {
    return null;
  }
}